/**
 * Ποιες γραμμές του πλέγματος τιμοκαταλόγων (OrgPriceListsManager) ΔΕΝ γράφονται σε
 * ονομαστικό τιμοκατάλογο.
 *
 * Μετά τη Φ5 το πλέγμα έχει ΜΟΝΟ γραμμές μεγέθους (απόφαση 35_price_list_flows_interpretation):
 * τιμή προϊόντος σε τιμοκατάλογο δεν υπάρχει (ο server απαντά 410 PRICE_IN_SIZES_ONLY), άρα δεν
 * υπάρχει και γραμμή προϊόντος να κλειδώσει. Μένει ένα κλείδωμα:
 *  - 'fee': μέγεθος προϊόντος-τέλους (κατάλοιπο, σχήμα 373). Ο server το δέχεται, αλλά δεν
 *    επηρεάζει κανένα ποσό — το τέλος χρεώνεται ΠΑΝΤΑ χωρίς μέγεθος με το ποσό του state_fees
 *    (απόφαση 1_fees_source). Ένα επεξεργάσιμο κελί που δεν αλλάζει τίποτα θα ήταν ψέμα.
 *
 * Ο «Βασικός» (lens 'default') ΔΕΝ κλειδώνει: γράφει στον κεντρικό κατάλογο (org_catalog_sizes),
 * όχι σε γραμμή τιμοκαταλόγου.
 */

export type PriceListRowLock = 'fee' | null;

export interface PriceListLockProduct {
  fee_category?: number | string | null;
}

export const isFeeLockProduct = (product: PriceListLockProduct | null | undefined): boolean =>
  !!product && product.fee_category !== null && product.fee_category !== undefined && product.fee_category !== '';

export function priceListRowLock({ lens, product }: {
  /** 'default' = Βασικός· αριθμός = ονομαστικός τιμοκατάλογος. */
  lens: number | 'default';
  /** Το κεντρικό προϊόν-γονέας της γραμμής μεγέθους. */
  product: PriceListLockProduct | null | undefined;
}): PriceListRowLock {
  if (lens === 'default') return null;
  return isFeeLockProduct(product) ? 'fee' : null;
}
